import firebase from 'firebase'
require("firebase/firestore")

// AUTHENTICATION
const initAuthStateChangeHandler = () => (dispatch) => {
    firebase.auth().onAuthStateChanged(
        user => {
            dispatch({type: 'USER_AUTH_STATE_CHANGED', data: user})

            if(user){
                firebase.firestore().collection("users").doc(user.uid).onSnapshot( 
                    (user) => user.exists && dispatch({type: 'EXISTING_USER', data: user.data()})
                )

                let links = firebase.firestore().collection('links').where('user_id', '==', user.uid)
                .get()
                .then( 
                    (querySnapshot) => {
                        var links = []
                        var connections = []
                        var plans = []
                        querySnapshot.forEach(  (doc) => {
                            if(doc){
                                let data = doc.data()
                                firebase.firestore().collection('connections').doc(data.connection_id).get().then(
                                    (doc) => connections.push(doc.data())
                                )
                                firebase.firestore().collection('plans').doc(data.plan_id).get().then(
                                    (doc) => plans.push(doc.data())
                                )
                                links.push(data)
                            }
                        });
                        dispatch({type: 'CONNECTIONS_FOUND', data: connections})
                        dispatch({type: 'PLANS_FOUND', data: plans})
                        dispatch({type: 'LINKS_FOUND', data: links})
                    }
                )
                .catch(
                    (error) => console.log("Error getting documents: ", error)
                )
            }
        }
    )
}

const authUserSignOut = () => (dispatch) => firebase.auth().signOut()
const createFirebaseAuthUI = () => (dispatch) => dispatch({type: 'CREATE_FIREBASE_AUTH_UI'})

export {
    initAuthStateChangeHandler,
    authUserSignOut,
    createFirebaseAuthUI
}


// WEBPACK FOOTER //
// ./src/redux/actions.js